import { render, staticRenderFns } from "./QueryAdditionalSettings.vue?vue&type=template&id=7edd84d5&"
import script from "./QueryAdditionalSettings.vue?vue&type=script&lang=js&"
export * from "./QueryAdditionalSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports